/**
 * Best Price Section PDP Logic - KALKI Fashion
 * Multi-currency dynamic exchange rate conversion for Max Cap
 */
(function () {
  function waitForCurrencyReady(cb, retries) {
    if (typeof retries === 'undefined') retries = 30;
    if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
      cb();
    } else if (retries > 0) {
      setTimeout(function () {
        waitForCurrencyReady(cb, retries - 1);
      }, 100);
    } else {
      cb();
    }
  }

  function getCurrencyRate() {
    if (window.Shopify && Shopify.currency && typeof Shopify.currency.rate !== 'undefined') {
      var rate = parseFloat(Shopify.currency.rate);
      if (!isNaN(rate) && rate > 0) return rate;
    }
    if (window.currencyRates && window.shopcurrency && typeof window.currencyRates[window.shopcurrency] !== 'undefined') {
      var r = parseFloat(window.currencyRates[window.shopcurrency]);
      if (!isNaN(r) && r > 0) return r;
    }
    return 1;
  }

  function formatMoneyAmount(cents, currencySymbol) {
    var symbol = currencySymbol || (window.Shopify && Shopify.currency && Shopify.currency.symbol) || '₹';
    var units = Math.round(cents / 100);
    // Use en-IN formatting for Rupee symbol, standard locale otherwise
    var formattedNum = (symbol === '₹')
      ? units.toLocaleString('en-IN')
      : units.toLocaleString();
    return symbol + formattedNum;
  }

  function getEffectiveCapCents(element) {
    if (!element) return 0;
    var baseCap = parseFloat(element.getAttribute('data-base-cap'));
    var rate = getCurrencyRate();
    if (!isNaN(baseCap) && baseCap > 0) {
      // Converted units multiplied by exchange rate, converted to cents
      return Math.round(baseCap * rate) * 100;
    }
    var rawCapCents = parseFloat(element.getAttribute('data-max-discount-cap') || element.getAttribute('data-tier-cap'));
    if (!isNaN(rawCapCents) && rawCapCents > 0) {
      return rawCapCents;
    }
    return 0;
  }

  function recalculateCard(card, currentPrice, comparePrice) {
    var currencySymbol = card.getAttribute('data-currency-symbol') || (window.Shopify && Shopify.currency && Shopify.currency.symbol) || '₹';
    var hasOffer = card.getAttribute('data-has-offer') === 'true';
    var offerPercent = parseFloat(card.getAttribute('data-offer-percent')) || 0;
    var hasProductDiscount = comparePrice > currentPrice;

    var container = card.closest('.kalki-best-price-container');

    // Rule: If no offer and no product discount, hide entire section
    if (!hasOffer && !hasProductDiscount) {
      if (container) container.style.display = 'none';
      return;
    } else {
      if (container) container.style.display = '';
    }

    var maxDiscountCapCents = getEffectiveCapCents(card);
    var offerSource = card.getAttribute('data-offer-source') || 'metafield';
    var couponType = card.getAttribute('data-coupon-type') || 'percent';
    var couponValue = parseFloat(card.getAttribute('data-coupon-value')) || 0;
    var couponMinCents = parseFloat(card.getAttribute('data-coupon-min-cents')) || 0;

    // Offer discount calculation
    var offerDiscountCents = 0;
    if (hasOffer) {
      if (offerSource === 'coupon') {
        if (currentPrice >= couponMinCents) {
          if (couponType === 'percent') {
            var pUnits = currentPrice / 100;
            var discUnits = Math.round(pUnits * (couponValue / 100));
            offerDiscountCents = discUnits * 100;
          } else {
            offerDiscountCents = couponValue * 100;
          }
        } else {
          offerDiscountCents = 0;
        }
      } else if (offerPercent > 0) {
        var priceUnits = currentPrice / 100;
        var offerDiscountUnits = Math.round(priceUnits * (offerPercent / 100));
        offerDiscountCents = offerDiscountUnits * 100;
      }
    }

    // Apply converted 3rd pipe Max Discount Cap if specified
    if (maxDiscountCapCents > 0) {
      if (offerDiscountCents > maxDiscountCapCents || (offerSource !== 'coupon' && offerDiscountCents === 0)) {
        offerDiscountCents = maxDiscountCapCents;
      }
    }

    if (offerDiscountCents > currentPrice) {
      offerDiscountCents = currentPrice;
    }

    var bestPriceCents = (hasOffer && offerDiscountCents > 0) ? Math.max(0, currentPrice - offerDiscountCents) : currentPrice;

    // Update Best Price in header
    var bestPriceEl = card.querySelector('[data-bp-best-price]');
    if (bestPriceEl) {
      bestPriceEl.textContent = formatMoneyAmount(bestPriceCents, currencySymbol);
    }

    // Update Offer / Max Tier discount row & value
    var offerValEl = card.querySelector('[data-bp-max-tier-discount], [data-bp-offer-val]');
    if (offerValEl) {
      if (hasOffer && offerDiscountCents > 0) {
        offerValEl.textContent = formatMoneyAmount(offerDiscountCents, currencySymbol);
        offerValEl.style.display = '';
      } else {
        offerValEl.style.display = 'none';
      }
    }

    var couponRow = card.querySelector('[data-bp-coupon-row]');
    if (couponRow) {
      if (hasOffer && offerDiscountCents > 0) {
        couponRow.style.display = '';
      } else {
        couponRow.style.display = 'none';
      }
    }

    // Update other tier rows
    var tierRows = card.querySelectorAll('.kalki-bp-tier-row');
    tierRows.forEach(function (row) {
      if (row.querySelector('[data-bp-max-tier-discount]')) return; // already updated above
      var rowPercent = parseFloat(row.getAttribute('data-tier-percent')) || 0;
      var rowCapCents = getEffectiveCapCents(row);
      var rowValEl = row.querySelector('.kalki-bp-item-val');
      if (rowPercent > 0 || rowCapCents > 0) {
        var rowDiscountCents = 0;
        if (rowPercent > 0) {
          var pUnits = currentPrice / 100;
          var discUnits = Math.round(pUnits * (rowPercent / 100));
          rowDiscountCents = discUnits * 100;
        }
        if (rowCapCents > 0) {
          if (rowDiscountCents > rowCapCents || rowDiscountCents === 0) {
            rowDiscountCents = rowCapCents;
          }
        }
        if (rowDiscountCents > 0) {
          if (!rowValEl) {
            rowValEl = document.createElement('span');
            rowValEl.className = 'kalki-bp-item-val';
            row.appendChild(rowValEl);
          }
          rowValEl.textContent = formatMoneyAmount(rowDiscountCents, currencySymbol);
          rowValEl.style.display = '';
        } else if (rowValEl) {
          rowValEl.style.display = 'none';
        }
      }
    });

    // Update Product discount value & row visibility
    var discountRow = card.querySelector('[data-bp-discount-row]');
    var discountVal = card.querySelector('[data-bp-discount-val]');
    if (comparePrice > currentPrice) {
      var discountCents = comparePrice - currentPrice;
      if (discountVal) {
        discountVal.textContent = formatMoneyAmount(discountCents, currencySymbol);
      }
      if (discountRow) {
        discountRow.style.display = 'flex';
      }
    } else {
      if (discountRow) {
        discountRow.style.display = 'none';
      }
    }
  }

  function initBestPrice() {
    var cards = document.querySelectorAll('[js-kalki-best-price]');
    cards.forEach(function (card) {
      var toggle = card.querySelector('[js-kalki-bp-toggle]');
      if (!toggle || toggle.dataset.bound === 'true') return;
      toggle.dataset.bound = 'true';

      toggle.setAttribute('aria-expanded', card.classList.contains('is-open') ? 'true' : 'false');

      function handleToggle(e) {
        if (e) e.preventDefault();
        var isOpen = card.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      toggle.addEventListener('click', handleToggle);
      toggle.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          handleToggle(e);
        }
      });

      // Recalculate once currency rate is ready
      waitForCurrencyReady(function () {
        var currentRate = getCurrencyRate();
        if (currentRate !== 1) {
          var currentPrice = parseFloat(card.getAttribute('data-current-price')) || 0;
          var comparePrice = parseFloat(card.getAttribute('data-compare-price')) || 0;
          if (currentPrice > 0) {
            recalculateCard(card, currentPrice, comparePrice);
          }
        }
      });
    });
  }

  function updateBestPriceForVariant(variant) {
    if (!variant) return;

    var cards = document.querySelectorAll('[js-kalki-best-price]');
    cards.forEach(function (card) {
      var price = Number(variant.price || 0);
      var comparePrice = Number(variant.compare_at_price || 0);
      card.setAttribute('data-current-price', price);
      card.setAttribute('data-compare-price', comparePrice);
      recalculateCard(card, price, comparePrice);
    });
  }

  window.initKalkiBestPrice = initBestPrice;
  window.updateKalkiBestPrice = updateBestPriceForVariant;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBestPrice);
  } else {
    initBestPrice();
  }

  // Subscribe to variant change events (Shopify Dawn PUB_SUB_EVENTS)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event && event.data && event.data.variant) {
        updateBestPriceForVariant(event.data.variant);
      }
    });
  }

  // Also support custom events or section reload
  document.addEventListener('kalki:best-price:init', initBestPrice);
})();
